import { setUserContext as setUserContextInTelemetryStore } from '@ms/yammer-telemetry-store';

import type { PromiseThunkAction } from '../../types';
import { getCurrentNetworkId, getCurrentSessionUser } from '../session/selectors';
import { getCurrentUserField } from '../users/selectors';

type SetTelemetryUserContext = () => PromiseThunkAction<void>;
export const setTelemetryUserContext: SetTelemetryUserContext = () => async (_dispatch, getState) => {
  const state = getState();
  const { id: userId } = getCurrentSessionUser(state);
  const officeUserId = getCurrentUserField(state, 'officeUserId');

  setUserContextInTelemetryStore({ userId, networkId: getCurrentNetworkId(state), officeUserId });
};
